export const translations = {
  appTitle: "TruckLoad 3D",
  appSubtitle: "Smart Load Planner",
  saveLoad: "Save / Load",
  addLoad: "Add Cargo",
  name: "Name",
  quantity: "Qty",
  length: "Length",
  width: "Width",
  height: "Height",
  weight: "Weight",
  stackable: "Stackable",
  maxStackWeight: "Max Stack W.",
  addPallets: "Add Pallets",
  noLoad: "No cargo added",
  truckStats: "Load Summary",
  totalWeight: "Total Weight",
  linearMeters: "Linear Meters (LDM)",
  overweight: "OVERWEIGHT!",
  aiAssistant: "Gemini AI Assistant",
  generateAdvice: "Generate Advice",
  analyzing: "Analyzing...",
  aiPlaceholder: "Add pallets and select truck type to receive specific advice.",
  rotate: "Rotate: Left Click + Drag",
  zoom: "Zoom: Mouse Wheel",
  move: "Pan: Right Click + Drag",
  dragItem: "Drag pallets to rearrange. Drop on top of others to stack.",
  customTruck: "Custom Dimensions",
  maxWeight: "Max Weight",
  unitSystem: "Unit System",
  language: "Language",
  advicePrompt: "Act as a logistics expert. Analyze this load for a",
  dotRegulations: "Mention DOT regulations for US",
  euRegulations: "Mention EN 12195 standards for EU",
  danger: "DANGER",
  safe: "Safe",
  truckType: "Truck Type",
  delete: "Delete",
  savedLoads: "Saved Loads",
  saveCurrent: "Save Current",
  loadName: "Configuration Name",
  save: "Save"
};